import React from 'react';
import {
	getDisplayNumberById
} from '../../../assets/cards/cards';
import BottomSheet from '../../../components/bottomsheet/BottomSheet';
import PrimaryButton from '../../../components/buttons/primarybutton/PrimaryButton';
import H1 from '../../../components/text/H1';

const DetectedCard = ({ color, displayName, cardId, onUnlockPressed }) => (
	<BottomSheet color={color} border padding>
		<div className="flex flex-row mb-4">
			<H1 shadow>{displayName}</H1>
			<div className="inline bg-white text-black font-bold text-lg rounded-full px-3 align-middle leading-8 shadow-md">
				{getDisplayNumberById(cardId)}
			</div>
		</div>
		<p className="mb-4">
			Leer alles over deze soort door de kaart te verzamelen!
		</p>
		<div className="text-center">
			<PrimaryButton
				animated
				color={color}
				onClick={onUnlockPressed}>
				Begin
			</PrimaryButton>
		</div>
	</BottomSheet>
);

export default DetectedCard;
